import image from "../assets/images/received_727610058633268.jpeg";
import projectImage from "../assets/images/steamuserimages-a.akamaihd.jpg";
import musicImage from "../assets/images/{B90228AC-E7C3-460D-9D49-E1955E19B1FD}.png";
import contactImage from "../assets/images/FB_IMG_1693257590414.jpg";

import { Link } from 'react-router-dom';
import { FaLaravel, FaPhp, FaHtml5, FaPython, FaReact, FaBootstrap, FaFigma, FaGithub } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { BsFiletypeSql } from "react-icons/bs";
import { BiLogoFlask, BiLogoTailwindCss } from "react-icons/bi";
import { VscVscode } from "react-icons/vsc";
import { SiNetlify, SiPhpmyadmin } from "react-icons/si";
import MusicCarousel from "../components/MusicCarousel";
import ProjectCarousel from "../components/ProjectCarousel";
import '../index.css';


const About = () => {
    return (
        <div className="min-h-screen">
            <div className="px-6 pt-14 lg:px-8">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl lg:mx-0">
                        <div className="flex items-center">
                            <h1 className="text-5xl font-semibold tracking-tight sm:text-7xl">Fintan Gallagher</h1>
                            <img className="w-24 h-auto ml-4" src={image} alt="About Me" />
                        </div>
                        <p className="mt-8 pb-12 text-lg font-medium sm:text-2xl">27 year old programmer with the mind of a 26 year old and the body of a 28 year old. Focused on front-end development with experience in ReactJS and Laravel Frameworks. Makes bad music.</p>
                    </div>
                    <hr className="my-8 border-t-2 border-gray-600" />
                    <div className="mt-10 flex justify-between flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0">
                        <Link to="/projects" className="group perspective">
                            <div className="relative w-64 h-64 duration-1000 transform-style-preserve-3d group-hover:rotate-y-180">
                                <div className="absolute inset-0 w-full h-full backface-hidden flex items-center justify-center">
                                    <img src={projectImage} alt="Project" className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                        <h1 className="text-2xl font-bold ">Projects</h1>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to="/contact" className="group perspective">
                            <div className="relative w-64 h-64 duration-1000 transform-style-preserve-3d group-hover:rotate-y-180">
                                <div className="absolute inset-0 w-full h-full backface-hidden flex items-center justify-center">
                                    <img src={contactImage} alt="Project" className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                        <h1 className="text-2xl font-bold ">Contact</h1>
                                    </div>
                                </div>
                            </div>
                        </Link>
                        <Link to="/music" className="group perspective">
                            <div className="relative w-64 h-64 duration-1000 transform-style-preserve-3d group-hover:rotate-y-180">
                                <div className="absolute inset-0 w-full h-full backface-hidden flex items-center justify-center">
                                    <img src={musicImage} alt="Project" className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                                        <h1 className="text-2xl font-bold ">Music</h1>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <hr className="my-8 border-t-2 border-gray-600" />
                    <div className="mt-10 ">
                        <div>
                            <h2 className="text-3xl font-bold mb-4">Projects</h2>
                            <ProjectCarousel />
                        </div>
                        <hr className="my-8 border-t-2 border-gray-600" />
                        <div>
                            <h2 className="text-3xl font-bold mb-4">Music</h2>
                            <MusicCarousel />
                        </div>

                    </div>
                    <hr className="mt-8 pt-8 border-t-2 border-gray-600" />
                    <div className="mt-10 min-h-screen">
                        <h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">Skills</h1>
                        <div className="mt-8">
                            <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Programming Languages</h1>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-4">
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><IoLogoJavascript /></i>
                                    <h1 className="mt-2 text-lg">JavaScript</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><BsFiletypeSql /></i>
                                    <h1 className="mt-2 text-lg">SQL</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaPhp /></i>
                                    <h1 className="mt-2 text-lg">PHP</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaHtml5 /></i>
                                    <h1 className="mt-2 text-lg">HTML/CSS</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaPython /></i>
                                    <h1 className="mt-2 text-lg">Python</h1>
                                </div>
                            </div>
                        </div>
                        <div className="mt-8">
                            <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Frameworks</h1>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-4">
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaLaravel /></i>
                                    <h1 className="mt-2 text-lg">Laravel</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaReact /></i>
                                    <h1 className="mt-2 text-lg">ReactJS</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><BiLogoFlask /></i>
                                    <h1 className="mt-2 text-lg">Python Flask</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><BiLogoTailwindCss /></i>
                                    <h1 className="mt-2 text-lg">Tailwind</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaBootstrap /></i>
                                    <h1 className="mt-2 text-lg">Bootstrap</h1>
                                </div>
                            </div>
                        </div>
                        <div className="mt-8">
                            <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Tools</h1>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-4">
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><VscVscode /></i>
                                    <h1 className="mt-2 text-lg">VS Code</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><SiNetlify /></i>
                                    <h1 className="mt-2 text-lg">Netlify</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaFigma /></i>
                                    <h1 className="mt-2 text-lg">Figma</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><FaGithub /></i>
                                    <h1 className="mt-2 text-lg">Git/GitHub</h1>
                                </div>
                                <div className="flex flex-col items-center">
                                    <i className="colored text-6xl"><SiPhpmyadmin /></i>
                                    <h1 className="mt-2 text-lg">PHPMyAdmin</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;